<template>
    <div v-if="isAuthenticated">
        <v-container fluid>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <v-card-title>Training Delivery {{trainingYear}}</v-card-title>

                    <YearlyBarChart type="training-year-total" :params="trainingParams" />
                    <v-card-actions>
                        <v-btn @click="prevTrainingYear">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn @click="nextTrainingYear">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="6">
                <v-card>
                    <v-card-title>Bookings {{bookingsYear}}</v-card-title>

                    <YearlyBarChart type="bookings-year-total" :params="bookingParams" />
                    <v-card-actions>
                        <v-btn @click="prevBookingYear">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn @click="nextBookingYear">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        </v-container>
    </div>
</template>

<script>

    import Dashboard from "../layouts/Dashboard";
    import YearlyBarChart from "../components/Chart/YearlyBarChart";
    import { mapGetters } from 'vuex'

    let thisYear = new Date().getFullYear()

    export default {
        name: "home",
        components: { YearlyBarChart },
        metaInfo: {
            title: 'Dashboard'
        },
        data: () => ({
            bookingsYear: thisYear,
            trainingYear: thisYear
        }),
        computed: {
            ...mapGetters('auth', [
                'isAuthenticated',
                'getUser',
            ]),
            bookingParams(){
                return {'year': this.bookingsYear}
            },
            trainingParams(){
                return {'year': this.trainingYear}
            }
        },
        created() {
            this.$emit('update:layout', Dashboard);
        },
        methods: {
            nextBookingYear() {
                this.bookingsYear = this.bookingsYear + 1
            },
            prevBookingYear() {
                this.bookingsYear = this.bookingsYear - 1
            },
            nextTrainingYear() {
                this.trainingYear = this.trainingYear + 1
            },
            prevTrainingYear() {
                this.trainingYear = this.trainingYear - 1
            },

        }
    };
</script>
